class ProductAddition extends HTMLElement {
  constructor() {
    super();

    this.variantSelect = this.querySelector(".js-variant-select");
    this.input = this.querySelector(".js-product-addition");
    this.option1 = this.querySelector(".js-option-select-1");
    this.option2 = this.querySelector(".js-option-select-2");
    this.option3 = this.querySelector(".js-option-select-3");

    this.selectedVariantId = this.variantSelect.value;

    this.initializeProductAddition();

    this.options = this.querySelectorAll(".js-complete-set-option");
    this.options.forEach((option) => {
      option.addEventListener("change", () => {
        this.getSelectedVariant();
        this.updateOptionSelects();
        this.fetchVariantPrice();
        this.input.value = this.selectedVariantId;
      });
    });
  }

  initializeProductAddition() {
    this.matchMainProductSizeOnLoad();
    this.getSelectedVariant();
    this.updateOptionSelects();
    this.fetchVariantPrice();
    this.input.value = this.selectedVariantId;
  }

  matchMainProductSizeOnLoad() {
    const mainProductForm = document.querySelector('product-form');
    if (!mainProductForm) return;

    const mainProductVariantSelect = mainProductForm.querySelector('[name="id"]');
    if (!mainProductVariantSelect) return;

    const selectedMainProductVariantId = mainProductVariantSelect.value;
    const mainProductSelectedOption = mainProductVariantSelect.querySelector(`option[value="${selectedMainProductVariantId}"]`);

    if (!mainProductSelectedOption) return;

    const mainProductOption1Value = mainProductSelectedOption.dataset.option1 || null;

    if (mainProductOption1Value && this.option1) {
      const variants = this.variantSelect.querySelectorAll("option");
      let matchedVariantByMainSize = null;

      for (const variantOption of variants) {
        const variantOption1Value = variantOption.getAttribute("data-option-1") || null;
        if (variantOption1Value === mainProductOption1Value) {
          matchedVariantByMainSize = variantOption;
          break;
        }
      }

      if (matchedVariantByMainSize) {
        this.selectedVariantId = matchedVariantByMainSize.value;
        this.option1.value = mainProductOption1Value;
        if (this.option2) this.option2.value = matchedVariantByMainSize.getAttribute("data-option-2") || '';
        if (this.option3) this.option3.value = matchedVariantByMainSize.getAttribute("data-option-3") || '';
      }
    }
  }

  updateOptionSelects() {
    const selectedVariantOption = this.variantSelect.querySelector(`option[value="${this.selectedVariantId}"]`);

    if (!selectedVariantOption) return;

    const variantOption1Value = selectedVariantOption.getAttribute("data-option-1") || '';
    const variantOption2Value = selectedVariantOption.getAttribute("data-option-2") || '';
    const variantOption3Value = selectedVariantOption.getAttribute("data-option-3") || '';

    if (this.option1) {
      this.option1.value = variantOption1Value;
    }
    if (this.option2) {
      this.option2.value = variantOption2Value;
    }
    if (this.option3) {
      this.option3.value = variantOption3Value;
    }
  }

  fetchVariantPrice() {
    fetch(`${this.dataset.url}?section_id=main-product&variant=${this.selectedVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const saleRegularSource = html.querySelector(".price__sale span > .price-item");
        const saleRegularDestination = this.querySelector(".price__sale span > .price-item");
        if (saleRegularSource && saleRegularDestination) {
          saleRegularDestination.innerHTML = saleRegularSource.innerHTML;
        }

        const salePriceSource = html.querySelector(".price__sale .price-item");
        const salePriceDestination = this.querySelector(".price__sale .price-item");
        if (salePriceSource && salePriceDestination) {
          salePriceDestination.innerHTML = salePriceSource.innerHTML;
        }

        const priceSource = html.querySelector(".price__regular .price-item");
        const priceDestination = this.querySelector(".price__regular .price-item");
        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
        }
      })
      .catch((error) => {
        console.error('Error fetching variant price:', error);
      });
  }

  getSelectedVariant() {
    const option1Value = this.option1 ? this.option1.value : null;
    const option2Value = this.option2 ? this.option2.value : null;
    const option3Value = this.option3 ? this.option3.value : null;

    const normalizedOption1 = option1Value === "" ? null : option1Value;
    const normalizedOption2 = option2Value === "" ? null : option2Value;
    const normalizedOption3 = option3Value === "" ? null : option3Value;

    const variants = this.variantSelect.querySelectorAll("option");
    let foundVariant = null;

    for (const variantOption of variants) {
      const variantOption1Value = variantOption.getAttribute("data-option-1") || null;
      const variantOption2Value = variantOption.getAttribute("data-option-2") || null;
      const variantOption3Value = variantOption.getAttribute("data-option-3") || null;

      if (
        variantOption1Value === normalizedOption1 &&
        variantOption2Value === normalizedOption2 &&
        variantOption3Value === normalizedOption3
      ) {
        foundVariant = variantOption;
        break;
      }
    }

    if (foundVariant) {
      this.selectedVariantId = foundVariant.getAttribute("value");
      return;
    }

    let bestMatch = null;
    let bestMatchScore = -1;

    for (const variantOption of variants) {
      const variantOption1Value = variantOption.getAttribute("data-option-1") || null;
      const variantOption2Value = variantOption.getAttribute("data-option-2") || null;
      const variantOption3Value = variantOption.getAttribute("data-option-3") || null;

      let currentMatchScore = 0;

      if (normalizedOption1 !== null) {
        if (variantOption1Value === normalizedOption1) {
          currentMatchScore += 100;
        } else {
          continue;
        }
      }

      if (normalizedOption2 !== null) {
        if (variantOption2Value === normalizedOption2) {
          currentMatchScore += 10;
        } else {
          continue;
        }
      }

      if (normalizedOption3 !== null) {
        if (variantOption3Value === normalizedOption3) {
          currentMatchScore += 1;
        } else {
          continue;
        }
      }

      if (currentMatchScore > bestMatchScore) {
        bestMatch = variantOption;
        bestMatchScore = currentMatchScore;
      }
    }

    if (bestMatch) {
      this.selectedVariantId = bestMatch.getAttribute("value");
    } else {
      const firstVariant = variants[0];
      if (firstVariant) {
        console.warn('No suitable variant found. Falling back to the first available variant.');
        this.selectedVariantId = firstVariant.getAttribute("value");
      } else {
        console.error('No variants available for complete-the-set product.');
        this.selectedVariantId = null;
      }
    }
  }
}

customElements.define("product-addition", ProductAddition);
